"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = request;
var _httpStatusCodes = _interopRequireDefault(require("http-status-codes"));
var _fetchPonyfill2 = _interopRequireDefault(require("fetch-ponyfill"));
var _fetchPonyfill = (0, _fetchPonyfill2.default)(),
  fetch = _fetchPonyfill.fetch;
function parseHttpStatus(response) {
  if (response.ok || response.status === _httpStatusCodes.default.UNAUTHORIZED) {
    return response.json();
  }
  return Promise.reject();
}
function parseResponse(res) {
  if (res && (res.code === 'JsonWebTokenError' || res.code === 'TokenExpiredError')) {
    return {
      error: 'invalid'
    };
  }
  if (res) {
    return res;
  }
  return Promise.reject();
}
function request(url, options) {
  return fetch(url, options).then(function (response) {
    return parseHttpStatus(response);
  }).then(function (res) {
    return parseResponse(res);
  }).catch(function (error) {
    return error;
  });
}